import { OutgoingMembershipProductDto } from 'api/dtos/memberships/products';

export enum CheckoutSteps {
  ProductsList = 'productsList',
  Summary = 'summary',
  Success = 'success'
}

export type ProductMetadata = {
  quantity: number;
};

export type CartItem = {
  productData: OutgoingMembershipProductDto;
  metadata: ProductMetadata;
};

export type NormalizedCart = Record<string, CartItem>;
